<template>
  <div>
    <appModalMsg></appModalMsg>
    <appModal></appModal>
    <appHeader></appHeader>
    <div class="container-fluid settings">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <router-view />
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import hrAdminSettingModal from "@/components/hrAdminSettingModal.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "AdminSettingsRoleAndPermissions",

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    appModal: hrAdminSettingModal,
    appModalMsg: Modal,
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "rolesAndPermissions",
        activeMenu: this.activeMenu ? this.activeMenu : "settings",
      });
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>
<style lang="scss" scoped>
.settings {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    // padding: 6px 8px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
}

html,
body {
  height: 100%;
}
</style>

